import {get, flatMap} from 'lodash';

const refactorOverlayProps = (ranges, specs) => {
  if (!ranges) {
    return []
  }
  return ranges.map(range => {
    return {
      id: range.id,
      rangeId: get(range, 'rangeId', range.id),
      title: range.title,
      models: range.series.map(item => {

        const models = specs && item.specs ? flatMap(item.specs, (spec) => {
          return spec.models
        }) : {};
        return {
          id: item.id,
          rangeId: range.id,
          rangeTitle: range.title,
          seriesTitle: item.title,
          image: get(item, 'models[0].image', null),
          models,
          ...item,
          specs: null
        }
      })
      }
    }
  )
}

const filterOverlayProps = (props, modelsOfInterest) => {
  if (!props) {
    return []
  }
  return props.map(item => {
    return {
      ...item,
      models: item.models.map(model => {
        return {
          ...model,
          models: model.models.filter(i => {
            return !modelsOfInterest.find(j => j.id === i.id)
          })
        }
      }).filter(model => {
        return (model.models && model.models.length > 0)
      })
    }
  }).filter(model => {
    return (model.models && model.models.length > 0)
  }).filter(range => {
    if (range.title && range.title.toLowerCase() === 'motorised') {
      return false;
    }
    return true;
  })
}

export {filterOverlayProps, refactorOverlayProps as default};